import { Fragment } from 'react'

import { Stack } from '@mui/material'

import { Checkbox } from '@/components/primitives/Checkbox'
import { useFormatSeconds } from '@/hooks'
import { WarningTriangle } from '@/icons'
import { Text, WarningCard } from '@/local/components'

import { useController } from '../hooks/useController'
import { useControllerActions } from '../hooks/useControllerActions'
import { useTexts } from '../useTexts'

const Block = Fragment

export function Body() {
  const texts = useTexts()
  const handlers = useControllerActions()
  const {
    status,
    data: { selectedOrders, pairedOrders, deleteAlsoPaired, mode },
  } = useController()

  const serviceTimeSec =
    !!pairedOrders && pairedOrders?.length === 1 ? pairedOrders[0].serviceTimeSec : 0
  const serviceTime = useFormatSeconds(serviceTimeSec)

  return (
    <Stack direction="column" width="100%" marginTop={4}>
      <Block>
        <WarningCard
          title={
            status !== 'pending' ? texts.warningCardTitle(mode) : texts.transactionWarningCardTitle
          }
          preset="warning"
          description={
            status !== 'pending'
              ? texts.warningCardDescription
              : texts.transactionWarningCardDescription
          }
          Icon={<WarningTriangle size={14} color="$pureWhite" background="$outrageousRed" />}
        />
      </Block>

      {!!pairedOrders && pairedOrders.length > 0 && (
        <Block>
          <Stack direction="row" width="100%" marginTop={4} alignItems="start">
            <Checkbox
              style={{ marginTop: 4 }}
              checked={deleteAlsoPaired}
              onChange={handlers.onDeleteAlsoPairedChange}
            />

            <Stack direction="column" width="100%">
              <Text size="$h2" weight="$semiBold" color="$nightRider" marginLeft={5} ellipsis>
                {mode === 'bulk'
                  ? texts.deleteAlsoBulk
                  : texts.deleteAlso(selectedOrders[0].orderStepType)}
              </Text>
              <Text
                ellipsis
                size="$p3"
                marginTop={2}
                marginLeft={5}
                weight="$regular"
                color="$nightRider"
              >
                {mode === 'bulk'
                  ? texts.subtitleBulk(pairedOrders.length)
                  : texts.subtitle({
                      name: selectedOrders[0].order.name,
                      serviceTime: serviceTimeSec !== undefined ? serviceTime : null,
                    })}
              </Text>
            </Stack>
          </Stack>
        </Block>
      )}
    </Stack>
  )
}
